import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AppUpdateDialogData {
  autoReloadDelayMinutes: number;
}

@Component({
  selector: 'sp-app-update-dialog',
  templateUrl: './app-update-dialog.component.html',
  styleUrls: ['./app-update-dialog.component.scss'],
})
export class AppUpdateDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AppUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppUpdateDialogData,
  ) {}

  public updateNow(): void {
    this.dialogRef.close('update-now');
  }

  public updateLater(): void {
    this.dialogRef.close('update-later');
  }
}
